import React from 'react';
import { Button } from 'antd';
import { getUser } from '../../utils/auth';

interface H5ProfilePageProps {
  onLogout: () => void;
}

const H5ProfilePage: React.FC<H5ProfilePageProps> = ({ onLogout }) => {
  const user = getUser();

  return (
    <div className="h5-page">
      <section className="h5-panel h5-profile-card">
        <div>
          <span className="h5-muted">当前账号</span>
          <h2>{user?.name || '用户'}</h2>
          <p>{user?.username || '-'}</p>
        </div>
        <Button danger block onClick={onLogout}>
          退出登录
        </Button>
      </section>
    </div>
  );
};

export default H5ProfilePage;
